import React from "react";

import { withContainer } from "../components";
import RegistrationForm from "../components/forms/RegistrationForm";

export const Registration = withContainer(RegistrationForm);
